import { DesktopDatePicker, LocalizationProvider } from "@mui/lab";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import {
  Box,
  Card,
  Grid,
  InputAdornment,
  TextField,
  Typography,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import moment from "moment";
import React from "react";
import SearchIcon from "@mui/icons-material/Search";
import { DataGrid } from "@mui/x-data-grid";
import { useState } from "react";
import api from "../../../components/services/api";
import { useEffect } from "react";
import { Link } from "react-router-dom";
export default function FinancialList() {
  const [dataFilter, setDataFilter] = useState([]);
  const [toCountry, setToCountry] = useState("all");
  const [location, setLocation] = useState([]);
  const [locationFilter, setLocationFilter] = useState([]);
  const [country, setCountry] = useState([]);
  const [toAction, setToAction] = useState("all");
  const [board, setBoard] = useState("all");
  const [key, setKey] = useState("");
  const [dateStart, setDateStart] = useState(null);
  const [dateEnd, setDateEnd] = useState(null);
  const getData = async () => {
    const res = await api.get(`api/financial/list`);
    const data = await res.data;
    if (res.meta.status === true) {
      setDataFilter(data);
    }
  };
  const SearchData = async () => {
    const res = await api.get(
      `api/financial/list?keyword=${key}${dateStart ? '&startDate=' + dateStart : ""}${
        dateEnd ? '&endDate=' + dateEnd : ""}${toCountry === "all" ? "" : '&countryId=' + toCountry}${
        toAction === "all" ? "" : '&locationId=' + toAction
      }${board === "all" ? "" : '&board=' + board}
      `
    );
    const data = await res.data;
    if (res.meta.status === true) {
      setDataFilter(data);
    }
  };

  const getCountry = async () => {
    try {
      const res = await api.get("api/country/list");
      const data = await res.data;
      if (res.meta.status === true) {
        setCountry(data.filter((x) => x?.Status === true));
      }
    } catch (e) {
      console.log(e);
    }
  };
  const getLocation = async () => {
    try {
      const res = await api.get("api/location/list");
      const data = await res.data;
      if (res.meta.status === true) {
        setLocation(data.filter((x) => x?.Status === true));
        setLocationFilter(data.filter((x) => x?.Status === true));
      }
    } catch (e) {
      console.log(e);
    }
  };
  useEffect(() => {
    if (toCountry !== 'all') {
      const filterLocation = location?.filter((item) => item.CountryId === toCountry)
      setLocationFilter(filterLocation)
      setToAction(filterLocation[0]?.LocationId)
    } else {
      setLocationFilter(location)
    }
  }, [toCountry])
  useEffect(() => {
    getLocation();
    getCountry();
    getData();
  }, []);
  const columns = [
    {
      field: "SaleOrderNo",
      headerName: "So No.",
      width: 150,
      renderCell: (params) => {
        return (
          <Link
            to={`/CustomerSupport/EditSaleOrder/${params?.row?.SaleOrderId}`}
          >
            <span>{params?.row?.SaleOrderNo}</span>
          </Link>
        );
      },
    },
    { field: "Type", headerName: "Type", width: 100 },
    { field: "CustomerName", headerName: "Customer", width: 250 },
    {
      field: "ETDGateOut",
      headerName: "ETDGateOut",
      width: 150,
      valueFormatter: ({ value }) => moment(value).format("yyyy/MM/DD"),
    },
    {
      field: "VoyOut",
      headerName: "VoyOut",
      width: 250,
    },
    { field: "Quantity", headerName: "Volume", width: 80 },
    { field: "Size", headerName: "Size", width: 80 },
    {
      field: "QuotationNo",
      headerName: "QT NO.",
      width: 150,
      renderCell: (params) => {
        return (
          <Link
            to={`/CustomerSupport/EditQuotation/${params?.row?.QuotationId}`}
          >
            <span>{params?.row?.QuotationNo}</span>
          </Link>
        );
      },
    },
    {
      field: "JobOrderNo",
      headerName: "JobOder",
      width: 150,
      renderCell: (params) => {
        return (
          <Link
            to={`/ContainerRepair/RepairDetail/${params?.row?.RepairContainerId}`}
          >
            <span>{params?.row?.JobOrderNo}</span>
          </Link>
        );
      },
    },
    {
      field: "IncomePerContainer",
      headerName: "Net Amt / Con.",
      width: 150,
      renderCell: (params) => {
        return (
          <span>
            {params?.row?.IncomePerContainer.toString().replace(
              /(\d+)(\d{3})/,
              "$1" + "," + "$2"
            )}
          </span>
        );
      },
    },
    {
      field: "TotalIncome",
      headerName: "Total Amt.",
      width: 150,
      renderCell: (params) => {
        return (
          <span>
            {params?.row?.TotalIncome.toString().replace(
              /(\d+)(\d{3})/,
              "$1" + "," + "$2"
            )}
          </span>
        );
      },
    },
    {
      field: "ExtraExpense",
      headerName: "Extra Expense",
      width: 150,
      renderCell: (params) => {
        return (
          <span>
            {params?.row?.ExtraExpense.toString().replace(
              /(\d+)(\d{3})/,
              "$1" + "," + "$2"
            )}
          </span>
        );
      },
    },
    {
      field: "AdvancePayment",
      headerName: "Advance Payment",
      width: 150,
      renderCell: (params) => {
        return (
          <span>
            {params?.row?.AdvancePayment.toString().replace(
              /(\d+)(\d{3})/,
              "$1" + "," + "$2"
            )}
          </span>
        );
      },
    },
    {
      field: "Cost",
      headerName: "Cost",
      width: 150,
      renderCell: (params) => {
        return (
          <span>
            {params?.row?.Cost.toString().replace(
              /(\d+)(\d{3})/,
              "$1" + "," + "$2"
            )}
          </span>
        );
      },
    },
  ];
  // const columnGroupingModel = [

  //     {
  //         groupId: 'Expen',
  //         children: [{ field: 'Extra' }, { field: 'Advance' }, { field: 'cost' }],
  //     },
  //     {
  //         groupId: 'Income',
  //         children: [
  //             {
  //                 field: 'Net'
  //             },
  //             { field: 'Total' },
  //         ],
  //     },
  // ];

  return (
    <div>
      <Card variant="outlined" style={{ padding: "20px", margin: "25px" }}>
        <h6 style={{ marginTop: "10px" }} className="textcolorgreen">
          รายการทางการเงิน
        </h6>

        <Grid container alignItems="center" spacing={1}>
          <Grid item xs>
            <Typography
              className="textcolordarkblue"
              variant="h5"
              component="h1"
            >
              Financial List
            </Typography>
          </Grid>
          <Grid item sx={{ display: "flex", flexDirection: "row" }}>
            <Typography className="textcolorBule">Financial</Typography>
            <Typography>
              <span>&nbsp;</span> / Financial List
            </Typography>
          </Grid>
        </Grid>

        <Grid
          container
          sx={{ justifyContent: "end" }}
          style={{ marginTop: "10px" }}
          alignItems="center"
        >
          <FormControl
            size="small"
            sx={{
              width: "15%",
              marginRight: "10px",
            }}
          >
            <InputLabel>Country</InputLabel>
            <Select
              label="Country"
              value={toCountry}
              InputLabelProps={{ shrink: true }}
              onChange={(e) => {
                setToCountry(e.target.value);
              }}
              // disabled={values.liners !== ""}
            >
              <MenuItem value={"all"}>ทั้งหมด</MenuItem>
              {country?.map((x) => (
                <MenuItem value={x?.CountryId}>{x?.CountryName}</MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl
            size="small"
            sx={{
              width: "15%",
              marginRight: "10px",
            }}
          >
            <InputLabel>Location</InputLabel>
            <Select
              label="Location"
              value={toAction}
              InputLabelProps={{ shrink: true }}
              onChange={(e) => {
                setToAction(e.target.value);
              }}
              // disabled={values.liners !== ""}
            >
              <MenuItem value={"all"}>ทั้งหมด</MenuItem>
              {locationFilter?.map((x) => (
                <MenuItem value={x?.LocationId}>{x?.LocationName}</MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl
            size="small"
            sx={{
              width: "15%",
              marginRight: "10px",
            }}
          >
            <InputLabel>Board</InputLabel>
            <Select
              label="Board"
              value={board}
              InputLabelProps={{ shrink: true }}
              onChange={(e) => {
                setBoard(e.target.value);
              }}
              // disabled={values.liners !== ""}
            >
              <MenuItem value={"all"}>ทั้งหมด</MenuItem>
              {["รถ", "รถไฟ", "เรือ"]?.map((x) => (
                <MenuItem value={x}>{x}</MenuItem>
              ))}
            </Select>
          </FormControl>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DesktopDatePicker
              label="Date Start"
              value={dateStart}
              inputFormat="yyyy/MM/dd"
              minDate={new Date("2017-01-01")}
              onChange={(newValue) => {
                setDateStart(moment(newValue).format("yyyy-MM-DD"));
              }}
              renderInput={(params) => (
                <TextField
                  size="small"
                  style={{ width: "200px", marginLeft: "10px" }}
                  {...params}
                />
              )}
            />
            <DesktopDatePicker
              label="Date End"
              value={dateEnd}
              inputFormat="yyyy/MM/dd"
              minDate={new Date(dateStart)}
              onChange={(newValue) => {
                setDateEnd(moment(newValue).format("yyyy-MM-DD"));
              }}
              renderInput={(params) => (
                <TextField
                  size="small"
                  style={{
                    width: "200px",
                    marginLeft: "10px",
                    marginRight: "10px",
                  }}
                  {...params}
                />
              )}
            />
          </LocalizationProvider>
          <TextField
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
              disableUnderline: true,
            }}
            label="Search"
            onChange={(e) => setKey(e.target.value)}
            size="small"
          />
          <Button
            style={{
              backgroundColor: "#0d6efd",
              color: "#fafafa",
              marginLeft: "10px",
            }}
            onClick={() => SearchData()}
          >
            <SearchIcon />
          </Button>
        </Grid>

        <Box
          sx={{
            height: 650,
            width: "100%",
            marginTop: "10px",
            "& .Active": {
              color: "#28A745",
            },
            "& .Inactive": {
              color: "#F53C56",
            },
          }}
        >
          <DataGrid
            getRowId={(r) => r.ItemId}
            experimentalFeatures={{ columnGrouping: true }}
            rows={dataFilter}
            columns={columns}
            checkboxSelection
            disableSelectionOnClick
            // columnGroupingModel={columnGroupingModel}
          />
        </Box>
      </Card>
      {/* {MenuActive.find((x) => x.ActionNo === "A061") && (
      <Link to="/Setting/AddBranch">
        <Fab color="primary" style={floating_action_style} aria-label="add">
          <AddIcon />
        </Fab>
      </Link>
    )} */}
    </div>
  );
}
